import * as api from "../Api";

export const yearStats = () => async (dispatch) => {
  try {
    const { data } = await api.yearStats();
    dispatch({ type: "YEAR_STATS", payload: data });
  } catch (error) {}
};
